<template>
  <button
    type="button"
    @click="handleClick"
    :disabled="isLoading"
    :class="[
      'w-full flex items-center justify-center gap-3 py-2.5 px-4 rounded-md font-medium text-sm transition-colors',
      'focus:outline-none focus:ring-2 focus:ring-offset-2 focus:ring-blue-500',
      'disabled:opacity-50 disabled:cursor-not-allowed',
      config.bgColor,
      config.textColor,
      config.borderColor
    ]"
  >
    <span v-if="isLoading" class="flex items-center gap-2">
      <i class="fas fa-spinner fa-spin"></i>
      Signing in...
    </span>
    <template v-else>
      <!-- eslint-disable-next-line vue/no-v-html -->
      <span v-html="config.icon" class="flex-shrink-0"></span>
      <span>{{ config.label }}</span>
    </template>
  </button>
</template>

<script>
import { mapActions, mapMutations } from 'vuex';
import { getProviderConfig } from '@/services/sso/SsoProviderRegistry';

export default {
  name: 'SsoButton',

  props: {
    provider: {
      type: String,
      required: true,
      validator: (v) => ['google', 'facebook', 'apple'].includes(v)
    }
  },

  emits: ['success', 'error'],

  data() {
    return {
      isLoading: false
    };
  },

  computed: {
    config() {
      return getProviderConfig(this.provider);
    }
  },

  methods: {
    ...mapActions('auth', ['ssoLogin']),
    ...mapMutations('auth', ['SET_ERROR']),

    async handleClick() {
      this.isLoading = true;
      this.SET_ERROR(null);

      try {
        const token = await this.config.getToken();
        const result = await this.ssoLogin({ provider: this.provider, token });

        if (result.success) {
          this.$emit('success');
        } else {
          this.$emit('error', result.error);
        }
      } catch (err) {
        // User closed the popup or provider threw a "coming soon" error
        const message = err.message || 'Sign-in failed. Please try again.';
        this.$emit('error', message);
      } finally {
        this.isLoading = false;
      }
    }
  }
};
</script>
